<script setup lang="ts">
/**
 * Modal "Session expirée" partagée /a/[slug] et /b/[slug].
 */
defineProps<{
  open: boolean;
  message: string;
  variant: 'a' | 'b';
}>();

defineEmits<{
  (e: 'dismiss'): void;
}>();
</script>

<template>
  <UModal :open="open" :ui="{ content: 'sm:max-w-sm sm:rounded-2xl! bg-white!', header: 'hidden!' }" :dismissible="false">
    <template #body>
      <div class="text-center pt-4 pb-1">
        <h3 class="text-4xl font-bold text-gray-900 mb-2">{{ $t("association.publicPage.sessionExpiree") }}</h3>
        <p class="text-sm text-gray-500 leading-relaxed">
          {{ message }}
        </p>
        <button
          class="mt-5 w-full py-3 rounded-xl text-sm font-semibold focus:outline-none"
          :class="variant === 'a'
            ? 'bg-[#212121] text-white hover:opacity-90 transition-opacity'
            : 'accent-btn'"
          @click="$emit('dismiss')"
        >
          {{ $t("association.publicPage.recommencer") }}
        </button>
      </div>
    </template>
  </UModal>
</template>

<style scoped>
.accent-btn {
  background: var(--accent, #212121);
  color: var(--accent-text, #fff);
}
.accent-btn:hover {
  opacity: 0.9;
}
</style>
